import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  FormGroup
} from "reactstrap";

const SuspenseAccount = () => {
  const [filters, setFilters] = useState({
    scheme: "All",
    remittanceFromDate: "",
    remittanceToDate: "",
    dateOfServiceFrom: "",
    dateOfServiceTo: "",
    memberNo: "",
    patientSurname: "",
    eftNo: "",
    accountNo: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };

  return (
    <Container fluid>
      <Card>
        <CardBody>
          <h5>Suspense Account</h5>

          {/* Scheme section */}
          <Row className="mt-3">
            <Col lg={6}>
              <FormGroup>
                <Label>Scheme</Label>
                <Input
                  type="select"
                  name="scheme"
                  value={filters.scheme}
                  onChange={handleChange}
                >
                  <option>All</option>
                  <option>Scheme A</option>
                  <option>Scheme B</option>
                </Input>
              </FormGroup>
            </Col>

             <Col lg={6}>
              <FormGroup>
                <Label>EFT no.</Label>
                <Input
                  type="text"
                  name="eftNo"
                  placeholder="Enter EFT no."
                  value={filters.eftNo}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>

          </Row>

          {/* Date range section */}
          <Row>
            <Col lg={6}>
              <FormGroup>
                <Label>Remittance from date</Label>
                <Input
                  type="date"
                  name="remittanceFromDate"
                  value={filters.remittanceFromDate}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
            <Col lg={6}>
              <FormGroup>
                <Label>Remittance to date</Label>
                <Input
                  type="date"
                  name="remittanceToDate"
                  value={filters.remittanceToDate}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <FormGroup>
                <Label>Date of service from</Label>
                <Input
                  type="date"
                  name="dateOfServiceFrom"
                  value={filters.dateOfServiceFrom}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
            <Col lg={6}>
              <FormGroup>
                <Label>Date of service to</Label>
                <Input
                  type="date"
                  name="dateOfServiceTo"
                  value={filters.dateOfServiceTo}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* Member and patient info */}
          <Row >
            <Col lg={6}>
              <FormGroup>
                <Label>Member no.</Label>
                <Input
                  type="text"
                  name="memberNo"
                  placeholder="Enter member no."
                  value={filters.memberNo}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
           <Col lg={6}>
              <FormGroup>
                <Label>Account no.</Label>
                <Input
                  type="text"
                  name="accountNo"
                  placeholder="Enter account no."
                  value={filters.accountNo}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* ETI and Account no */}
          <Row >
             <Col lg={6}>
              <FormGroup>
                <Label>Patient surname</Label>
                <Input
                  type="text"
                  name="patientSurname"
                  placeholder="Enter patient surname"
                  value={filters.patientSurname}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
            
          </Row>

          {/* Buttons */}
          <div className="d-flex justify-content-end mt-4">
            <Button color="secondary" className="me-2">
              Clear
            </Button>
            <Button color="warning">Search</Button>
          </div>
        </CardBody>
      </Card>
    </Container>
  );
};

export default SuspenseAccount;